import api from './index';

const url = 'data';

export default {
	async createAnalyticEvent(event, data) {
		return api.post(`${url}/analytic/event/${event}`, data);
	},
};
